import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Navbar from "./Navbar";
import { getCurrentUser } from "../api/users";
import { t } from "../i18n";

export default function AppLayout() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadCurrentUser() {
            try {
                const currentUser = await getCurrentUser();
                setUser(currentUser);
            } catch (error) {
                console.error("Unable to load current user", error);
                window.location.replace("/login");
            } finally {
                setLoading(false);
            }
        }

        loadCurrentUser();
    }, []);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                {t("app.loading")}
            </div>
        );
    }

    return (
        <>
            <Navbar user={user} />

            <main className="container py-4">
                <Outlet context={{ user }} />
            </main>
        </>
    );
}
